import { styled, TableCell, TableHead, TableRow } from '@mui/material';

export const CustomTableHead = styled(TableHead)(
  ({ theme }) => `
          th {
            border-bottom: 2px solid ${theme.palette.brand.black};
            font-weight : 700;
            font-size: 1rem;
          }
        `,
);

export const CustomTableRow = styled(TableRow)`
  display: flex;
`;

export const CustomTableCell = styled(TableCell)<{ flex?: number }>(
  ({ flex }) => `
  ${flex ? 'display: flex' : ''};
  flex: ${flex ? flex : 1};
  font-size: 16px;
  align-items: center;
  gap: 5px;

  & a {
    color: inherit;
  }
`,
);
